<template>
  <!-- 案件詳細 -->
  <div id="KenshinDetailEdit">
    <div id="container" style="width:1300px">
      <div class="labelTitle lable">企業検診 受付内容編集</div>
      <div class="button-area">
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <span style="font-size: 20px">検診情報</span>
          <table>
            <tr>
              <th>受付番号</th><td>{{data.receptionNo}}</td>
            </tr>
            <tr>
              <th>発注元企業名</th><td style="word-break: break-word;">{{data.orderCompanyName}}</td>
            </tr>
            <tr><th>検査種類<span class="require"/></th>
              <td v-if="data.notDeviceReserve">
                <select v-model="data.inspectionType" class="deliveryInfo" name="検査種類" validate="required">
                  <option v-for="kind in inspectionKindList" :value="kind.value" :key="kind.value">{{ kind.label1 }}</option>
                </select>
              </td>
              <td v-else>{{data.inspectionType | getNameFilter(inspectionKindList)}}</td>
            </tr>
            <tr>
              <th>機種<span class="require"/></th>
              <td v-if="data.notDeviceReserve"><select id="model" v-model="data.modelId"><option v-for="device in kenshinDeviceList" :value="device.value" :key="device.value">{{ device.label1 }}</option></select></td>
              <td v-else>{{data.modelId | getNameFilter(kenshinDeviceList)}}</td>
            </tr>
            <tr>
              <th>判定有無<span class="require"/></th>
              <td><div class="block">
                <b-radio class="td_radio" v-model="data.isJudgment" :disabled="!data.notDeviceReturn" :native-value="true">する</b-radio>
                <b-radio class="td_radio" v-model="data.isJudgment" :disabled="!data.notDeviceReturn" :native-value="false">しない</b-radio>
              </div></td>
            </tr>
            <tr v-if="data.isJudgment">
              <th>判定医<span class="require"/></th>
              <td><input id="judgmentName" type="text" readonly v-model="data.judgmentName" disabled style="width:500px;height:28px;" validate="required" class="deliveryInfo" name="判定医"/><b-button v-if="data.notDeviceReturn" style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">判定医選択</b-button></td>
            </tr>
            <tr>
              <th class="deliverySlip_label">納品書</th>
              <td><div>
                <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="data.deliverySlip" :native-value="true">必要</b-radio>
                <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="data.deliverySlip" :native-value="false">不要</b-radio>
              </div></td>
            </tr>
            <tr>
              <th>デモ</th>
              <td><b-checkbox class="cstmCheckBox" v-model="data.demo">デモ(トライアル)</b-checkbox></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">検診情報備考</th>
              <td><textarea v-model="data.note" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
            </tr>
          </table>
        </div>
        <div id="item-contens">
          <div class="card-content margin-top">
          <span style="font-size: 20px">配送先情報</span>
          <table>
            <tr>
              <th>事業所名<span class="require" /></th>
              <td><input type="text" v-model="data.enterpriseName" class="deliveryInfo" name="事業所名" validate="required" maxlength="256"/></td>
            </tr>
            <tr v-if="data.expectedShippingDate">
              <th>出荷予定日<span class="require" /></th>
              <td><input id="expectedShippingDate" style="width:150px;" type="text" v-model="data.expectedShippingDate" disabled placeholder="年/月/日"/><a v-if="data.officeEditFlag" @click="stockCalenderActive = true"><b-icon icon="calendar-cursor"></b-icon></a></td>
            </tr>
            <tr>
              <th>装置配送先<span class="require" /></th>
              <td>
                <b-field>
                  <span class="zip-mark">〒</span>
                  <input
                    id="deviceDeliveryZip"
                    v-model="data.deviceDeliveryZip"
                    type="text"
                    class="zip-area deliveryInfo"
                    :class="{'border-red': invalidShippingPostcode}"
                    name="装置配送先郵便番号"
                    validate="required|numeric|zip"
                    maxlength="7"
                    :placeholder="postcodePlaceholder"
                    @blur="onZipBlur(data.deviceDeliveryZip, 'digitErrorDeviceDeliveryZip')"/>
                  />
                  <b-button
                    class="passButton"
                    v-on:click="addressSearch(data.deviceDeliveryZip,'device')"
                  >
                    自動入力
                  </b-button>
                </b-field>
                <div v-if="invalidShippingPostcode" class="text-red invalidPostcode">{{ invalidNumberMessage }}</div>
                <div v-if="digitErrorDeviceDeliveryZip" class="text-red invalidPostcode">{{ digitErrorZipMessage }}</div>
              </td>
            </tr>
            <tr>
              <th></th>
              <td>住所：<input v-model="data.deviceDeliveryAddress" type="text" style="margin-left:5px;width:870px;" class="deliveryInfo" name="装置配送先住所" validate="required" maxlength="256" ref="deviceDeliveryAddress"/></td>
            </tr>
            <tr>
              <th></th>
              <td>
                連絡先(電話番号)：
                <input
                  v-model="data.phoneNumber"
                  style="width: 790px;"
                  :placeholder="phonePlaceholder"
                  type="text"
                  class="deliveryInfo"
                  :class="{'border-red': invalidShippingPhoneNumber}"
                  name="装置配送先の連絡先(電話番号)"
                  validate="required|numeric"
                  maxlength="11"
                />
                <div v-if="invalidShippingPhoneNumber" class="text-red invalidPhoneNumber">{{ invalidNumberMessage }}</div>
              </td>
            </tr>
            <tr>
              <th></th>
              <td>宛名：<input v-model="data.deviceDeliveryName" type="text" style="width:875px;" class="deliveryInfo" name="装置配送先宛名" validate="required" maxlength="100"/></td>
            </tr>
            <tr v-if="!data.screeningFlag">
              <th>診断結果</th>
              <td><b-checkbox id="checked" style="width:26px;" v-model="data.resultDelivery" />装置配送先と異なる住所に送付する。</td>
            </tr>
          </table>
          <table id="appedTable" v-if="data.screeningFlag && data.officeEditFlag">
            <tr>
              <th>診断結果送付先</th>
              <td>
                <b-field>
                  <span class="zip-mark">〒</span>
                  <input
                    id="resultDeliveryZip"
                    v-model="data.resultDeliveryZip"
                    type="text"
                    class="zip-area deliveryInfo"
                    :class="{'border-red': invalidDeliveryPostcode}"
                    name="診断結果送付先郵便番号"
                    validate="required|numeric|zip"
                    maxlength="7"
                    :placeholder="postcodePlaceholder"
                    @blur="onZipBlur(data.resultDeliveryZip, 'digitErrorResultDeliveryZip')"/>
                  />
                  <b-button
                    class="passButton"
                    v-on:click="addressSearch(data.resultDeliveryZip,'result')"
                  >
                    自動入力
                  </b-button>
                </b-field>
                <div v-if="invalidDeliveryPostcode" class="text-red invalidPostcode">{{ invalidNumberMessage }}</div>
                <div v-if="digitErrorResultDeliveryZip" class="text-red invalidPostcode">{{ digitErrorZipMessage }}</div>
              </td>
            </tr>
            <tr>
              <th></th>
              <td>住所:
                <input id="resultDeliveryAddress" v-model="data.resultDeliveryAddress" type="text" style="margin-left:5px;width:885px;" name="診断結果送付先住所" maxlength="256" ref="resultDeliveryAddress"/>
              </td>
            </tr>
            <tr>
              <th>宛名</th>
              <td><input id="resultDeliveryName" v-model="data.resultDeliveryName" type="text" name="診断結果送付先宛名" maxlength="100"/></td>
            </tr>
          </table>
          <table id="appedTable" v-else-if="data.screeningFlag || data.resultDelivery">
            <tr>
              <th>診断結果送付先<span class="require" /></th>
              <td>
                <b-field>
                  <span class="zip-mark">〒</span>
                  <input
                    id="resultDeliveryZip"
                    v-model="data.resultDeliveryZip"
                    type="text"
                    class="zip-area deliveryInfo"
                    :class="{'border-red': invalidDeliveryPostCode}"
                    name="診断結果送付先郵便番号"
                    validate="required|numeric"
                    maxlength="7"
                    :placeholder="postcodePlaceholder"
                    @blur="onZipBlur(data.resultDeliveryZip, 'digitErrorResultDeliveryZip')"/>
                  />
                  <b-button
                    class="passButton"
                    v-on:click="addressSearch(data.resultDeliveryZip,'result')"
                  >
                    自動入力
                  </b-button>
                </b-field>
                <div v-if="invalidDeliveryPostCode" class="text-red invalidPostcode">{{ invalidNumberMessage }}</div>
                <div v-if="digitErrorResultDeliveryZip" class="text-red invalidPostcode">{{ digitErrorZipMessage }}</div>
              </td>
            </tr>
            <tr>
              <th></th>
              <td>住所:
                <input id="resultDeliveryAddress" v-model="data.resultDeliveryAddress" type="text" style="margin-left:5px;width:885px;" class="deliveryInfo" name="診断結果送付先住所" validate="required" maxlength="256" ref="resultDeliveryAddress"/>
              </td>
            </tr>
            <tr>
              <th>宛名</th>
              <td><input id="resultDeliveryName" v-model="data.resultDeliveryName" type="text" class="deliveryInfo" name="診断結果送付先宛名" validate="required" maxlength="100"/></td>
            </tr>
          </table>
          </div>
        </div>
        <div id="item-contens">
          <div class="card-content margin-top">
            <span style="font-size: 20px">検診G受付情報</span>
          <table>
            <tr>
                <th style="vertical-align:top;">検診G受付備考</th>
                <td><textarea v-model="data.receptionNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
            </tr>
            </table>
          </div>
        </div>
        <div id="item-contens" v-if="data.kawagoeReceptionFlag">
          <div class="card-content margin-top">
            <span style="font-size: 20px">川越受付情報</span>
            <table>
            <tr>
                <th style="vertical-align:top;">川越受付備考</th>
              <td><textarea v-model="data.kawagoeNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
            </tr>
          </table>
        </div>
        </div>
        <div class="card-content margin-top">
          <span style="font-size: 20px">被験者リスト</span>
          <input style="width:100px;float: right; margin-right: 25px;" type="button" value="行追加" :disabled="data.screeningFlag || !data.editFlag || originalRowData!=null" @click="addRow()" />
          <table>
            <tr>
              <th class="th_no">No.</th>
              <th class="th_name">姓<span class="require" /></th>
              <th class="th_name">名<span class="require" /></th>
              <th class="th_name">セイ<span class="require" /></th>
              <th class="th_name">メイ<span class="require" /></th>
              <th class="th_birth">生年月日</th>
              <th class="th_gender">性別</th>
              <th class="th_id">社員番号</th>
              <th class="th_status">ステータス</th>
              <th class="th_serial">シリアル</th>
              <th class="th_remarks">備考</th>
              <th class="th_edit">編集</th>
            </tr>
            <template v-for="(menber,rowNum) in data.subjectList">
              <tr :key="rowNum">
                <td>{{('000' + (rowNum+1)).slice(-3)}}</td>
                <td><input :disabled="menber.mode!='edit'" type="text" v-model="menber.familyName" :class="'edit_'+rowNum" name="姓" validate="required|patientName|max50" maxlength="100"/></td>
                <td><input :disabled="menber.mode!='edit'" type="text" v-model="menber.firstName" :class="'edit_'+rowNum" name="名" validate="required|patientName|max50" maxlength="100"/></td>
                <td><input :disabled="menber.mode!='edit'" type="text" v-model="menber.familyNameKana" :class="'edit_'+rowNum" name="姓(カナ)" validate="required|patientNameKana|max50" maxlength="100"/></td>
                <td><input :disabled="menber.mode!='edit'" type="text" v-model="menber.firstNameKana" :class="'edit_'+rowNum" name="名(カナ)" validate="required|patientNameKana|max50" maxlength="100"/></td>
                <td><input :disabled="menber.mode!='edit'" type="date" v-model="menber.birthday" :class="'edit_'+rowNum" name="生年月日" validate="date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())"/></td>
                <td>
                  <div class="block">
                    <b-radio class="td_radio width30" :disabled="menber.mode!='edit'" :name='"gender_"+ rowNum' size="is-small" native-value="-" v-model="menber.gender" >-</b-radio>
                    <b-radio class="td_radio width30" :disabled="menber.mode!='edit'" :name='"gender_"+ rowNum' size="is-small" native-value="男" v-model="menber.gender" >男</b-radio>
                    <b-radio class="td_radio width30" :disabled="menber.mode!='edit'" :name='"gender_"+ rowNum' size="is-small" native-value="女" v-model="menber.gender" >女</b-radio>
                  </div>
                </td>
                <td>
                  <input :disabled="menber.mode!='edit'" type="text" v-model="menber.employeeNumber" maxlength="100"/>
                </td>
                <td>
                  <span v-if="menber.status" :class="getTagClass(menber.status)" style="height:25px;width:90%;margin-left:5px;">{{getStatusName(menber.status)}}</span>
                </td>
                <td>
                  {{menber.serial}}
                </td>
                <td>
                  <input :disabled="menber.mode!='edit'" type="text" v-model="menber.remarks" maxlength="100" style="width:140px;"/>
                </td>
                <td>
                  <input v-if="menber.mode=='show'" type="button" style="height:25px;width:80px;" value="編集" @click="edit(menber)" />
                  <input v-if="menber.mode=='show'" type="button" style="height:25px;width:80px;" value="削除" :disabled="!menber.editFlag || data.subjectList.length==1" @click="deleteItem(menber)" />
                  <input v-if="menber.mode=='edit'" type="button" style="height:25px;width:80px;" value="保存" @click="save(menber,rowNum)" />
                  <input v-if="menber.mode=='edit'" type="button" style="height:25px;width:80px;font-size:85%;" value="キャンセル" @click="editCancel(menber)" />
                </td>
              </tr>
            </template>
          </table>
        </div>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" @click="receptionist">更新</b-button>
          <b-button class="receptionistButton is-primary" :disabled="!data.editFlag" @click="cancelReasonInputModalActive=true">検査をキャンセル</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
        <b-modal :active.sync="subjectCancelReasonInputModalActive" has-modal-card>
          <reasonInputModal  v-on:setReason="cancelItem" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
        </b-modal>
        <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
          <reasonInputModal  v-on:setReason="cancel" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
        </b-modal>
        <b-modal :active.sync="stockCalenderActive" has-modal-card>
          <stockCalenderModal :deviceKind="data.modelId" :count="getShippingUnits()" :receptionNo="this.targetNumber" @select="setShippingDate"></stockCalenderModal>
        </b-modal>
      </div>
      <b-modal :active.sync="organizationModalActive" has-modal-card>
        <judgmentDoctorSelectModal :selectRole="[role.role_judgment]" @select="setJudgmentName"></judgmentDoctorSelectModal>
      </b-modal>
    </div>
  </div>
</template>

<script>
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import StockCalenderModal from "@/components/mock/philips/kenshin/stock/StockCalender";
import JudgmentDoctorSelectModal from "@/components/mock/philips/common/JudgmentDoctorSelectModal";
import {
  role,
  requestStatus,
  choicesType,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  digitErrorZipMessage,
} from "@/components/mock/base/const.js";
export default {
  name: "KenshinDetailEdit",
  methods: {
    setJudgmentName: function(selectedJudgment){
      this.data.judgmentId = selectedJudgment.belongsId;
      this.data.judgmentName = selectedJudgment.hospitalName;
    },
    back: function () {
      this.$router.push({
        name: "KenshinRequestContentChange",
        params: { searchConditions: this.searchParams },
      });
    },
    doSearch: function() {
      var excuteApi = this.getKenshinReceptionContentsDetailPOST;
      var successCallBack = this.getKenshinReceptionContentsDetailPOSTSuccess;
      var errorCallBack = this.getKenshinReceptionContentsDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinReceptionContentsDetailPOST: function(client) {
      return client.apis.internalKenshin.getKenshinReceptionContentsDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getKenshinReceptionContentsDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.officeId = this.data.subjectList[0].officeId
      if(this.data.screeningFlag){
        this.inspectionKindList =　this.inspectionKindList.filter((val) => {return val.label3 == "スクリーニング"})
      }
    },
    getKenshinReceptionContentsDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
    addRow: function() {
      this.originalRowData = {}
      for(const rowData of this.data.subjectList){
        rowData.mode = "none"
      }
      this.data.subjectList.push({
        name:"",
        namekana:"",
        birthday:"",
        gender:"-",
        employeeNumber:"",
        remarks:"",
        officeId:this.officeId,
        receiptNumber:this.targetNumber,
        editFlag:true,
        mode:'edit'})
    },
    edit: function(item) {
      this.originalRowData = JSON.parse(JSON.stringify(item));
      for(const rowData of this.data.subjectList){
        rowData.mode = "none"
      }
      item.mode = "edit"
      this.$forceUpdate()
    },
    editCancel: function(item) {
      if(item.id){
        var resetData = JSON.parse(JSON.stringify(this.originalRowData));
        for(var i=0; i<this.data.subjectList.length; i++){
          if(this.data.subjectList[i].id==item.id){
            this.data.subjectList[i] = resetData
            break;
          }
        }
      }else{
        this.data.subjectList.splice(this.data.subjectList.length-1, 1);
      }
      this.originalRowData = null
      for(const rowData of this.data.subjectList){
        rowData.mode = "show"
      }
      this.$forceUpdate()
    },
    deleteItem: function(item) {
      this.updateData = JSON.parse(JSON.stringify(item));
      this.updateData.mode = "delete"
      this.subjectCancelReasonInputModalActive = true
    },
    cancelItem: function(cancelReason) {
      // 検査をキャンセル
      this.updateData.reason = cancelReason
      this.updateData.receiptNumber = this.targetNumber;
      this.updateData.version = this.data.version;
      var excuteApi = this.setKenshinSubjectListUpdatePOST;
      var successCallBack = this.setKenshinSubjectListUpdatePOSTSuccess;
      var errorCallBack = this.setKenshinSubjectListUpdatePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    save: function(item,index) {
      // バリデーションチェック
      var elements = document.getElementsByClassName("edit_"+index)
      var result = this.selfMadeValidation(elements)
      if(result.msg){
        this.showErrorMessage(result.msg)
        return
      }
      
      this.updateData = JSON.parse(JSON.stringify(item));
      this.updateData.name = this.updateData.familyName + " " + this.updateData.firstName
      this.updateData.namekana = this.updateData.familyNameKana + " " + this.updateData.firstNameKana
      this.updateData.mode = "edit"
      this.updateData.receiptNumber = this.targetNumber;
      this.updateData.version = this.data.version;
      var excuteApi = this.setKenshinSubjectListUpdatePOST;
      var successCallBack = this.setKenshinSubjectListUpdatePOSTSuccess;
      var errorCallBack = this.setKenshinSubjectListUpdatePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinSubjectListUpdatePOST: function(client) {
      return client.apis.internalKenshin.setKenshinSubjectListUpdatePOST({
        body:this.updateData
      });
    },
    setKenshinSubjectListUpdatePOSTSuccess: function(result) {
      this.updateData = null
      this.originalRowData = null
      this.showSuccess(result,this.doSearch());

    },
    setKenshinSubjectListUpdatePOSTError: function(result) {
      // エラーメッセージ表示
      this.updateData = null
      this.showErrorMessage(result);
    },
    receptionist: function() {
      var errMsg = ""
      // バリデーションチェック
      var elements = document.getElementsByClassName("deliveryInfo")
      var result = this.selfMadeValidation(elements)
      errMsg = result.msg

      if(errMsg){
        this.showErrorMessage(errMsg)
        return
      }
      var excuteApi = this.setKenshinReceptionContentsUpdatePOST;
      var successCallBack = this.setKenshinReceptionContentsUpdatePOSTSuccess;
      var errorCallBack = this.setKenshinReceptionContentsUpdatePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinReceptionContentsUpdatePOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.officeId = this.officeId
      obj.receiptNumber = this.targetNumber
      obj.editFlag = this.data.editFlag
      obj.version = this.data.version
      if(!obj.isJudgment){
        obj.judgmentId = null;
        obj.judgmentName = null;
      }
      if(!obj.resultDelivery){
        obj.resultDeliveryZip = "";
        obj.resultDeliveryAddress = "";
        obj.resultDeliveryName = "";
      }

      return client.apis.internalKenshin.setKenshinReceptionContentsUpdatePOST({
        body:obj
      });
    },
    setKenshinReceptionContentsUpdatePOSTSuccess: function(result) {
      this.originalRowData = null
      this.showSuccess(result,this.doSearch());
    },
    setKenshinReceptionContentsUpdatePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    cancel: function(cancelReason) {
      // 検査をキャンセル
      this.reason = cancelReason
      var excuteApi = this.setKenshinReceptionInspectionCancelPOST;
      var successCallBack = this.setKenshinReceptionInspectionCancelPOSTSuccess;
      var errorCallBack = this.setKenshinReceptionInspectionCancelPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinReceptionInspectionCancelPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.officeId = this.officeId
      obj.receiptNumber = this.targetNumber
      obj.editFlag = this.data.editFlag
      obj.reason = this.reason
      return client.apis.internalKenshin.setKenshinReceptionInspectionCancelPOST({
        body:obj
      });
    },
    setKenshinReceptionInspectionCancelPOSTSuccess: function(result) {
      this.reason = ""
      this.showSuccess(result,this.back());
    },
    setKenshinReceptionInspectionCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.reason = ""
      this.showErrorMessage(result);
    },
    addressSearch: function(zip,target) {
      this.searchTargetPostCode = zip
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        if(target=="result"){
          this.data.resultDeliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          // QA476 住所設定後フォーカスを移動する
          this.focusMove("resultDeliveryAddress");
          this.digitErrorResultDeliveryZip = false;
        }else{
          this.data.deviceDeliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          // QA476 住所設定後フォーカスを移動する
          this.focusMove("deviceDeliveryAddress");
          this.digitErrorDeviceDeliveryZip = false;
        }
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      this.searchTargetPostCode = ""
    },
    setShippingDate: function(date){
      this.data.expectedShippingDate = this.yyyy_sla_MM_sla_dd(date);
      this.stockCalenderActive = false;
    },
    getShippingUnits: function() {
      var res = 0;
      for (var subject of this.data.subjectList) {
        if (subject.status == requestStatus.deviceReady ||
            subject.status == requestStatus.shippingReady) {
          res++;
        }
      }
      return res;
    },
    getStatusName: function(code) {
      var target = this.statusList.find(val => val.code && val.code.includes(code))
      if(target){
        return target.name
      }
      return ""
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      this[flagName] = zipCode.length < 7;
    },
    /**
     * QA476
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
          const element = this.$refs[refName];
          if (element) {
            element.focus();
            const length = element.value.length;
            element.setSelectionRange(length, length);
          }
      })
    },
  },
  data() {
    var targetNumber = decodeURIComponent(this.$route.query["receiptNumber"]);
    var searchParams = this.$route.params["searchConditions"];
    var statusList =[
      {name:"未受付", code:"[1]"}
     ,{name:"企業検診G受付済", code:"[11]"}
     ,{name:"川越受付済", code:"[2]"}
     ,{name:"出荷準備中", code:"[3]"}
     ,{name:"出荷済み", code:"[4]"}
     ,{name:"機器受領済み", code:"[5]"}
     ,{name:"再検査調整中", code:"[16]"}
     ,{name:"データ抽出済", code:"[100]"}
     ,{name:"判定依頼中", code:"[12]"}
     ,{name:"判定結果作成中", code:"[9]"}
     ,{name:"完了", code:"[13,14,15,18]"}
     ,{name:"キャンセル", code:"[17]"}
    ]
    let kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    let inspectionKindList = this.getChoiceList(choicesType.kenshinKind, false);
    return {
      targetNumber,
      searchParams,
      data:{
        subjectList:[]
      },
      originalRowData: null,
      updateData:null,
      officeId:null,
      searchTargetPostCode:null,
      searchTargetAddress:null,
      cancelReasonInputModalActive:false,
      subjectCancelReasonInputModalActive:false,
      stockCalenderActive: false,
      reason:"",
      statusList,
      kenshinDeviceList,
      inspectionKindList,
      organizationModalActive: false,
      role: role,
      invalidPostcode: false,
      invalidPhoneNumber: false,
      digitErrorZipMessage,
      digitErrorDeviceDeliveryZip:false,
      digitErrorResultDeliveryZip:false,
      isInitialZip:true,
      isInitialDeliveryZip:true,
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.doSearch();
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    reasonInputModal:reasonInputModal,
    stockCalenderModal: StockCalenderModal,
    judgmentDoctorSelectModal:JudgmentDoctorSelectModal
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  watch: {
    "data.deviceDeliveryZip"(newValue) {
      this.invalidShippingPostcode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      if (this.isInitialZip) {
        this.isInitialZip = false;
        return
      }
      if (!this.invalidShippingPostcode && newValue.length === 7) {
        this.addressSearch(newValue, 'device');
      }
    },
    "data.phoneNumber"(newValue) {
      this.invalidShippingPhoneNumber = isNaN(Number(newValue));
    },
    "data.resultDeliveryZip"(newValue) {
      this.invalidDeliveryPostCode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      if (this.isInitialDeliveryZip) {
        this.isInitialDeliveryZip = false;
        return
      }
      if (!this.invalidDeliveryPostCode && newValue.length === 7) {
        this.addressSearch(newValue,'result');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.zip-mark {
  margin-top:10px;
  margin-right:29px;
}
.zip-area {
  width: 270px;
  margin-top: 10px;
  margin-right: 10px;
}
.passButton{
  margin-top:10px;
  height:30px;
}
.th_no {
  width: 10px !important;
  margin-left: 5px;
}
.th_name {
  width: 90px !important;
  margin-left: 5px;
}
.th_birth {
  width: 30px !important;
  margin-left: 5px;
}
.th_gender {
  width: 115px !important;
  padding-left: 5px;
}
.th_id {
  width: 100px !important;
  margin-left: 5px;
}
.th_status{
  width: 80px !important;
  padding-left: 10px;
}
.th_serial{
  width: 100px !important;
  padding-left: 5px;
}
.th_remarks {
  width: 100px !important;
  margin-left: 5px;
}
.th_edit {
  width: 170px !important;
  padding-left: 30px;
}
.width30 {
  width:20px !important;
}
.invalidPostcode {
  margin-top: -8px;
  margin-left: 45px;
}
.invalidPhoneNumber {
  margin-top: 4px;
  margin-left: 135px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinDetailEdit.vue